import { t } from 'i18n';

export const NavItems = [
  {
    get label() {
      return t('navigation.organizations');
    },
    to: '/organizations',
    icon: 'pe-7s-gym',
    disableForRoles: ['group_admin'],
  },
  {
    get label() {
      return t('navigation.admins');
    },
    to: '/admins',
    icon: 'pe-7s-user',
  },
  {
    get label() {
      return t('navigation.users');
    },
    to: '/users',
    icon: 'pe-7s-user',
    disableForRoles: ['group_manager', 'chain_manager'],
    checkAvailable: (role, canCreateLicenses) => {
      if (role === 'group_admin' || role === 'admin') return true;
      if (role === 'group_manager' && canCreateLicenses) return true;
      return false;
    },
  },
  {
    get label() {
      return t('navigation.hybridUsers');
    },
    to: '/hybrid-users',
    icon: 'pe-7s-id',
    disableForRoles: ['admin', 'group_manager', 'chain_manager'],
  },
  {
    get label() {
      return t('navigation.licenses');
    },
    to: '/licenses',
    icon: 'pe-7s-file',
  },
  {
    get label() {
      return t('navigation.licenseTypes');
    },
    to: '/license-types',
    icon: 'pe-7s-albums',
    disableForRoles: ['group_manager', 'chain_manager', 'group_admin'],
  },
  {
    get label() {
      return t('navigation.powerboxes');
    },
    to: '/powerboxes',
    icon: 'pe-7s-box2',
    disableForRoles: ['group_manager'],
  },
  {
    get label() {
      return t('navigation.usageReports');
    },
    to: '/ems-usage-reports',
    icon: 'pe-7s-safe',
    disableForRoles: ['group_manager', 'chain_manager'],
  },
  {
    get label() {
      return t('navigation.appLogs');
    },
    to: '/app-logs',
    icon: 'pe-7s-note2',
    disableForRoles: ['group_manager', 'chain_manager', 'group_admin'],
  },
  {
    get label() {
      return t('navigation.blacklist');
    },
    to: '/blacklists',
    icon: 'pe-7s-junk',
    disableForRoles: ['group_manager', 'chain_manager', 'group_admin'],
    checkAvailable: (role, canCreateLicenses) => {
      if (role === 'admin') return true;
      if (role === 'group_manager' && canCreateLicenses) return true;
      return false;
    },
  },
];

const getNav = (userRole) => {
  return NavItems.filter((el) => {
    if (el.disableForRoles && el.disableForRoles.indexOf(userRole) !== -1) return false;
    return true;
  });
};

export const navItemsByRole = {
  admin: getNav('admin'),
  group_manager: getNav('group_manager'),
  chain_manager: getNav('chain_manager'),
  group_admin: getNav('group_admin'),
};
